import { o as EMPTY_ARRAY } from "./helpers-bwfx1e-Y.js";
import { c } from "react/compiler-runtime";
import { useDebugValue, useEffect } from "react";
import { useEffectEvent } from "use-effect-event";
/**
* @public
*/
function useClickOutsideEvent(listener, t0, boundaryElement) {
	let $ = c(9), elementsArg = t0 === void 0 ? _temp : t0, t1;
	$[0] !== boundaryElement || $[1] !== elementsArg || $[2] !== listener ? (t1 = (evt) => {
		if (!listener) return;
		let target = evt.target;
		if (!(target instanceof Node)) return;
		let resolvedBoundaryElement = boundaryElement?.();
		if (resolvedBoundaryElement && !resolvedBoundaryElement.contains(target)) return;
		let elements = elementsArg().flat();
		for (let el of elements) if (el && (target === el || el.contains(target))) return;
		listener(evt);
	}, $[0] = boundaryElement, $[1] = elementsArg, $[2] = listener, $[3] = t1) : t1 = $[3];
	let onEvent = useEffectEvent(t1), hasListener = !!listener, t2;
	$[4] !== hasListener || $[5] !== onEvent ? (t2 = () => {
		if (!hasListener) return;
		let handleEvent = (evt_0) => onEvent(evt_0);
		return document.addEventListener("mousedown", handleEvent), () => {
			document.removeEventListener("mousedown", handleEvent);
		};
	}, $[4] = hasListener, $[5] = onEvent, $[6] = t2) : t2 = $[6];
	let t3;
	$[7] === hasListener ? t3 = $[8] : (t3 = [hasListener], $[7] = hasListener, $[8] = t3), useEffect(t2, t3), useDebugValue(listener ? "MouseDown On" : "MouseDown Off");
}
function _temp() {
	return EMPTY_ARRAY;
}
export { useClickOutsideEvent as t };

//# sourceMappingURL=useClickOutsideEvent-lEVhDFCQ.js.map